import { put, call, takeLeading } from "redux-saga/effects";
import request from "utils/api";
import { safe } from "providers/GeneralProvider/saga";
import {
  getRealtimeStatsRequest,
  getRealtimeStatsSuccess,
  getHourlyStatsRequest,
  getHourlyStatsSuccess,
  getDailyStatsRequest,
  getDailyStatsSuccess,
  getMonthlyStatsRequest,
  getMonthlyStatsSuccess,
  getPeakHoursRequest,
  getPeakHoursSuccess,
  getHeatmapStatsRequest,
  getHeatmapStatsSuccess,
  getOnlineUsersRequest,
  getOnlineUsersSuccess,
  stopLoading,
} from "providers/UserActivityProvider/slice";

function* getRealtimeStats() {
  const response = yield call(request, "api/admin/user-activity/realtime", {}, { method: "GET" });
  yield put(getRealtimeStatsSuccess(response.data));
}

function* getHourlyStats(action) {
  const { startDate, endDate } = action.payload;
  const response = yield call(
    request,
    `api/admin/user-activity/hourly`,
    { startDate, endDate },
    { method: "GET" }
  );
  yield put(getHourlyStatsSuccess(response.data));
}

function* getDailyStats(action) {
  const { startDate, endDate } = action.payload;
  const response = yield call(
    request,
    `api/admin/user-activity/daily`,
    { startDate, endDate },
    { method: "GET" }
  );
  yield put(getDailyStatsSuccess(response.data));
}

function* getMonthlyStats(action) {
  const { year } = action.payload;
  const params = year ? { year } : {};
  const response = yield call(
    request,
    `api/admin/user-activity/monthly`,
    params,
    { method: "GET" }
  );
  yield put(getMonthlyStatsSuccess(response.data));
}

function* getPeakHours(action) {
  const { startDate, endDate, limit } = action.payload;
  const response = yield call(
    request,
    `api/admin/user-activity/peak-hours`,
    { startDate, endDate, limit: limit || 10 },
    { method: "GET" }
  );
  yield put(getPeakHoursSuccess(response.data));
}

function* getHeatmapStats(action) {
  const { startDate, endDate } = action.payload;
  const response = yield call(
    request,
    "api/admin/user-activity/heatmap",
    { startDate, endDate },
    { method: "GET" }
  );
  yield put(getHeatmapStatsSuccess(response.data));
}

function* getOnlineUsers() {
  const response = yield call(
    request,
    "api/admin/user-activity/online-users",
    {},
    { method: "GET" }
  );
  yield put(getOnlineUsersSuccess(response.data));
}

function* onError() {
  yield put(stopLoading());
}

export default function* watchUserActivity() {
  yield takeLeading(getRealtimeStatsRequest.type, safe(getRealtimeStats, onError));
  yield takeLeading(getHourlyStatsRequest.type, safe(getHourlyStats, onError));
  yield takeLeading(getDailyStatsRequest.type, safe(getDailyStats, onError));
  yield takeLeading(getMonthlyStatsRequest.type, safe(getMonthlyStats, onError));
  yield takeLeading(getPeakHoursRequest.type, safe(getPeakHours, onError));
  yield takeLeading(getHeatmapStatsRequest.type, safe(getHeatmapStats, onError));
  yield takeLeading(getOnlineUsersRequest.type, safe(getOnlineUsers, onError));
}
